import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Typography,
  CircularProgress,
  Paper,
  Chip,
  Divider,
} from '@material-ui/core';

import DashboardLayout from '../../dashboard/components/DashboardLayout';
import Alert from '../../common/components/Alert';
import SearchFormTabs from '../components/SearchFormTabs';

import * as searchActions from '../actions';
import classes from '../../css/getCSS';
import * as routes from '../../config/routes';


class SavedSearch extends Component {
  componentDidMount() {
    document.title = 'Saved Search';
    window.scrollTo(0, 0);
    this.props.getSavedSearch(this.props.token);
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  delete = (id) => {
    this.props.deleteSavedSearch(
      this.props.token,
      id,
    );
  }

  search = (data) => {
    this.props.history.push(
      formatRoute(routes.SEARCH_RESULTS),
    );
    window.localStorage.setItem('SELECTED_VALUES', data);
  }

  render() {
    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let content = null;

    if (this.props.saved) {
      content = this.props.saved.map((item) => {
        return (
          <div key={item.id}>
            <div className={classes.padding10}>
              <div>Search saved on {item.created_on}</div>
              <br />
              <Chip color="primary" clickable onClick={() => this.search(item.data)} label="Search" />
              <Chip color="primary" clickable onClick={() => this.delete(item.id)} label="Delete" />
            </div>
            <Divider />
          </div>
        );
      });
    }


    if (this.props.saved && this.props.saved.length === 0 && !this.props.loading) {
      content = (
        <div align="center">
          <Typography variant="body1">No Saved Searches found!</Typography>
        </div>
      );
    }

    return (
      <DashboardLayout
        isAuthenticated
        activeLink="search"
        user={this.props.user}
      >
        <SearchFormTabs
          type="saved"
        />
        <Paper className={[classes.card].join(' ')} style={{ marginTop: '7px' }}>
          {loading}
          {errorAlert}
          {content}
        </Paper>
      </DashboardLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    loading: state.search.loading,
    error: state.search.error,
    saved: state.search.saved,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(searchActions.onUnmount()),
    getSavedSearch: token => dispatch(searchActions.getSavedSearch(token)),
    deleteSavedSearch: (token, id) => dispatch(searchActions.deleteSavedSearch(token, id)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SavedSearch));



// WEBPACK FOOTER //
// ./src/search/containers/SavedSearch.js